import React, {useCallback, useEffect, useState} from 'react';
import {IOwnProps} from './model';
import {AccordionRewardShopView} from './AccordionRewardShopView';
import {useAccordionState} from './useFilterAccordionStateHandler/useAccordionState';

export const AccordionRewardShop: React.FC<IOwnProps> = (props) => {
  const {isOpen, handleAccordionState, setIsOpen} = useAccordionState();
  const [expanded, setExpanded] = useState(isOpen === props.accordionId);

  useEffect(() => {
    if (isOpen === props.accordionId) {
      setExpanded(true);
    } else {
      setExpanded(false);
    }
  }, [isOpen]);

  const handleChange = () => {
    handleAccordionState(props.accordionId);
  };

  const closeAccordion = useCallback(() => {
    setExpanded(false);
    setIsOpen('');
  }, []);

  return AccordionRewardShopView({
    ...props,
    expanded,
    closeAccordion,
    onPress: handleChange,
  });
};
